import { useLoadingSpinner } from 'reservations/base/providers/LoadingSpinnerProvider';
import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import { BaseChecklessPaymentsButton } from 'reservations/checklessPayments/components/BaseChecklessPaymentsButton';
import { usePaymentProviderSubmission } from 'reservations/payments/hooks/usePaymentProviderSubmission';

// This component is used to save a token in state rather than
// immediately submit it to the back end
export const RetrieveTokenButton = () => {
  const { handleHasLoaded, handleIsLoading } = useLoadingSpinner();
  const { open } = useModal();

  const onSuccess = () => {
    open(ModalType.ChecklessAddTip);
    handleHasLoaded();
  };
  const handleSubmission = usePaymentProviderSubmission(onSuccess);

  const onSubmit = () => {
    handleIsLoading('');
    handleSubmission();
  };

  return (
    <BaseChecklessPaymentsButton
      dataTestId="retrieve-token-button"
      buttonText="NEXT"
      handleClick={onSubmit}
    />
  );
};
